import React from 'react'
import { Text, Checkbox } from 'react-form'
import {Link} from 'react-router'
import {Form, Col, FormGroup, Button, ControlLabel, Row, OverlayTrigger, Tooltip} from 'react-bootstrap'
import {MdHelpOutline} from '../Common/ReactIcons/icons'
import ProgressBar from '../Common/ProgressBar/ProgressBar'

export default ({submitForm, message, isLoading}) => {
  const tooltip = (
    <Tooltip id="tooltip">فراموشی رمز عبور!</Tooltip>
  )

  return (
    <Form horizontal onSubmit={submitForm}>
      <Row className="FormWrapper">
        <FormGroup>
          <Col componentClass={ControlLabel} xs={4}>
            نام کاربری
          </Col>
          <Col xs={7}>
            <Text
              placeholder="ایمیل یا شماره موبایل"
              field="username"
              type="text"
              className="form-control"
            />
          </Col>
        </FormGroup>

        <FormGroup>
          <Col componentClass={ControlLabel} xs={4}>
            رمز عبور
          </Col>
          <Col xs={7}>
            <Text
              placeholder="رمز عبور"
              field="password"
              type="password"
              className="form-control"
            />
            <Link to="/forget-password" className="forgot-password-icon" >
              <OverlayTrigger placement="top" overlay={tooltip}>
                <MdHelpOutline />
              </OverlayTrigger>
            </Link>
          </Col>
        </FormGroup>

        <FormGroup>
          <Col xsOffset={4} xs={8}>
            <label className="inline-checkbox remember-me-checkbox">
              <Checkbox
                field="remember_me"
                placeholder="مرا به خاطر بسپار"
              />
              <span>مرا به خاطر بسپار</span>{' '}
            </label>
          </Col>
        </FormGroup>

        <FormGroup>
          <Col xsOffset={4} xs={7}>
            <Button type="submit" className={`btnBlock ${isLoading && 'disabled'}`} bsStyle="success">
              ورود
            </Button>
            <ProgressBar isLoading={isLoading} type="button" />
          </Col>
        </FormGroup>
      </Row>
    </Form>
  )
}



// WEBPACK FOOTER //
// ./src/components/Login/LoginForm.js